import { useCallback } from 'react';
import { useHistory } from 'react-router';
import { localeIgnoreCaseEquals } from 'common/utilities/String';
import { History } from 'history';
import { dashboardPath } from 'Routes';
import { useWebView } from 'store/webView/useWebView';

export const useNavigation = (): {
  navigateTo: (href: string, useWebViewNavigate?: boolean) => void;
  goBack: (useWebViewNavigate?: boolean) => void;
} => {
  const history: History = useHistory();
  const { isWebView, isWebViewReady } = useWebView();

  const navigateTo: (href: string, useWebViewNavigate?: boolean) => void = useCallback(
    (href: string, useWebViewNavigate = false) => {
      if (useWebViewNavigate && isWebView && localeIgnoreCaseEquals(href, dashboardPath)) {
        if (isWebViewReady) {
          window.nativeAppApi.goBack();
        }
      } else {
        history.push(href);
      }
    },
    [isWebView, isWebViewReady, history]
  );

  const goBack: (useWebViewNavigate?: boolean) => void = useCallback(
    (useWebViewNavigate = false) => {
      if (useWebViewNavigate && isWebView) {
        if (isWebViewReady) {
          window.nativeAppApi.goBack();
        }
      } else {
        history.goBack();
      }
    },
    [history, isWebView, isWebViewReady]
  );

  return { navigateTo, goBack };
};
